import { SVGProps, Ref, forwardRef } from 'react';

export const EmojiSadOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M6.998 7.032H4.332v-1.4h2.666z" fill="currentColor" />
            <path d="M8.998 7.032h2.666v-1.4H8.998z" fill="currentColor" />
            <path
                d="M6.375 11.696c-.23.245-.343.523-.343.8h-1.4c0-.681.284-1.29.723-1.758.632-.674 1.599-1.074 2.643-1.074s2.01.4 2.643 1.074c.44.468.723 1.077.723 1.759h-1.4c0-.278-.113-.556-.343-.8-.34-.363-.923-.633-1.623-.633s-1.282.27-1.623.632"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M.5 8C.5 1.438 1.438.5 8 .5s7.5.938 7.5 7.5-.937 7.5-7.5 7.5S.5 14.563.5 8m1.4 0c0-1.63.06-2.808.225-3.681.162-.86.4-1.287.654-1.54.253-.253.68-.492 1.54-.654C5.192 1.96 6.37 1.9 8 1.9s2.808.06 3.681.225c.86.162 1.287.4 1.54.654.253.253.492.68.654 1.54.165.873.225 2.051.225 3.681s-.06 2.808-.225 3.681c-.162.86-.4 1.287-.654 1.54-.253.253-.68.492-1.54.654-.873.165-2.051.225-3.681.225s-2.808-.06-3.681-.225c-.86-.162-1.287-.4-1.54-.654-.253-.253-.492-.68-.654-1.54C1.96 10.808 1.9 9.63 1.9 8"
                fill="currentColor"
            />
        </g>
    </svg>
));
EmojiSadOutlinedSize16Glyph.displayName = 'EmojiSadOutlinedSize16Glyph';
